module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "characters-in-the-story-in-the-order-of-appearance"
    }
  }, [_c('h1', [_vm._v("Characters in the Story in the"), _c('br'), _vm._v(" Order of Appearance")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dao –")]), _vm._v(" Thai female, Bussaba’s and Arun’s daughter, a senior student")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Yai")]), _vm._v(" – Thai male, Dao’s boyfriend, a senior student")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Ying –")]), _vm._v(" Dao’s classmate and friend")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Teacher "), _c('strong', [_vm._v("Bundit")]), _vm._v(" – middle-aged Thai male, crewcut hair, jovial, practical, authoritative, slightly overweight; has relative working in an important position in the Tourist Association of Thailand")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Teacher "), _c('strong', [_vm._v("Mali")]), _vm._v(" – Thai female with long hair tied back, grave character, kind, multilingual, teaches mathematics")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Warun")]), _vm._v(" – Thai male, waterworks official")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Bussaba")]), _vm._v(" – Thai female, owner of the restaurant and grocery shop")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Boriphoon")]), _vm._v(" – Thai male graduating student at the teacher’s college, a middle-built, well-groomed city boy from the capitol city of Bangkok")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Chai")]), _vm._v(" – Thai male, Boriphoon’s classmate, well-tanned, son of a local fruit farmer, light built, handsome, very adept at agricultural skills")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Achara")]), _vm._v(" – daughter of the Lisu hill tribe village chief in western central Thailand, now performing at the light and sound show; also working part-time at the nearby shop Bussaba’s")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Teacher "), _c('strong', [_vm._v("Parin")]), _vm._v(" – tall Thai female, teaches biology, social sciences, and history")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Lek")]), _vm._v(" – Thai male, fourth-generation Portuguese background, prominent nose, PTA leader")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Nin")]), _vm._v(" – Thai female, third generation Indian background, PTA leader")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Ananda")]), _vm._v(" – Thai male, local police officer, municipality officer, police chief")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Saengdao")]), _vm._v(" – Thai female, sells fruit at the local market and at the sound and light show, mother of Chai, wife of Kiat")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Teacher "), _c('strong', [_vm._v("Chariya")]), _vm._v(" – small Thai lady, teaches music, the local Rotary club leader; make-up stylist for the light and sound show")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Kasem")]), _vm._v(" – Thai male chief of subdistrict")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Hom")]), _vm._v(" – female, wife of Kasem, panellist in the dance contest in the light and sound show")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Chantana")]), _vm._v(" – male relative of Chai, an electric store owner")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0